<template>
  <g stroke="null" fill-rule="evenodd" fill="none">
    <path d="M-9.44-94.07h19.787v19.786H-9.439V-94.07z" />
    <path
      d="M7.05 2.377V.111H5.688v2.266h1.36zm2.683 1.674l1.602-1.601-.96-.96-1.603 1.6.962.961h-.001zm-6.728 0l.961-.96-1.601-1.602-.961.961 1.601 1.601zM8.552 11.2l2.563-2.562-4.324-4.325-2.564 2.563L8.552 11.2h0zm-6.26-4.063v-1.36H.026v1.36h2.266zm.073 4.286l1.601-1.603-.96-.962-1.602 1.603.96.96v.002zm14.884 8.476l2.563-2.564L12.076 9.6l-2.562 2.562 7.735 7.737z"
      fill-rule="nonzero"
      :fill="color"
    />
  </g>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      required: true
    }
  }
};
</script>
